/**
 * 20% / 50% / MAX chips. They report a percentage and the caller does BigInt
 * arithmetic on the base-unit balance, so shown and submitted amounts cannot drift.
 */

const PERCENTS = [20, 50, 100] as const;

export function AmountShortcuts({
  onPick,
  disabled = false,
}: {
  onPick: (percent: number) => void;
  disabled?: boolean;
}) {
  return (
    <span className="amount-shortcuts">
      {PERCENTS.map((percent) => (
        <button
          key={percent}
          type="button"
          className="amount-chip"
          disabled={disabled}
          onClick={() => onPick(percent)}
        >
          {percent === 100 ? "MAX" : `${percent}%`}
        </button>
      ))}
    </span>
  );
}
